module.exports = __webpack_public_path__ + "media/images/pricing/pricing-starter-97c9c717bd08d57b63eeb090f7cdf709.svg";